import {
  COMMUNITY_FILE_EXTENSIONS,
  COMMUNITY_FILE_MIME_TYPES,
  PORTAL_FILE_EXTENSIONS,
  PORTAL_FILE_MIME_TYPES,
} from '@src/constants/fileTypes';

export interface EditorConfig {
  maxFiles: number;
  maxSize: number;
  acceptedFileTypes: string[];
  acceptedFileExtensions: string[];
}

export const CommunityEditorConfig: EditorConfig = {
  maxFiles: 5,
  maxSize: 10 * 1024 * 1024,
  acceptedFileTypes: COMMUNITY_FILE_MIME_TYPES,
  acceptedFileExtensions: COMMUNITY_FILE_EXTENSIONS,
};

export const PortalEditorConfig: EditorConfig = {
  maxFiles: Infinity,
  maxSize: 25 * 1024 * 1024,
  acceptedFileTypes: PORTAL_FILE_MIME_TYPES,
  acceptedFileExtensions: PORTAL_FILE_EXTENSIONS,
};
